// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3xW84","description":"PatientConsentPreview_description__3knrz"};